import { lazy, Suspense } from 'react'
import PageMeta from 'src/_shared/components/PageMeta'
import Hero from 'src/pages/ContactUs/components/Hero'

const Contact = lazy(() => import('src/pages/ContactUs/components/Contact'))
const Form = lazy(() => import('src/pages/ContactUs/components/Form'))

export const ContactUs = (): JSX.Element => {
	return (
		<div>
			<PageMeta
				title="Contact Voltality - Get in Touch"
				description="Contact Voltality for inquiries about our EV charging solutions, eRoaming network, and corporate fleet services. We're here to help."
			/>
			<Hero />
			<Suspense fallback={<></>}>
				<div className="relative flex flex-col">
					<Contact />
					<Form />
				</div>
			</Suspense>
		</div>
	)
}
